import React from 'react'
import { useRequest } from 'ahooks'
import request from 'meinian-package/src/utils/request'
import omit from 'lodash/omit'
import values from 'lodash/values'
import { MultiSelect } from 'meinian-package/src/baseComponent/selectBorder'
import css from './formItem.module.less'

export const FormItem = ({ label, children }) => (
  <div className={css.formItem}>
    <div className={css.label}>{label}</div>
    {children}
  </div>
)
const useUserOptions = (params) => {
  const { data = [] } = useRequest(
    async () => {
      try {
        if (!params.searchKey) {
          return []
        }
        const res = (await request.post('/zhikuan/inspiration/get-search-creator', params)) as any
        return (
          res?.map((m) => {
            return { label: m.nickName, value: m.userId }
          }) || []
        )
      } catch (error) {
        return []
      }
    },
    {
      debounceWait: 300,
      refreshDeps: [...values(omit(params, ['userIdList', 'start', 'pageSize']))],
    }
  )
  return data
}

export const UserFormItem = ({ label, onChange, value, params, hasResult }) => {
  const options = useUserOptions(params)
  if (hasResult) {
    return (
      <FormItem label={label}>
        <MultiSelect
          menuMaxHeight={400}
          allowClear
          multiple
          placeholder="不限"
          value={value}
          onChange={onChange}
          option={options}
        />
      </FormItem>
    )
  }
  return null
}
